export default __webpack_public_path__ + "static/media/instagram.75e79bb0.svg";